import timelineScallop1Src from '@images/marketing/Team-Numbers-1.jpg';
import timelineScallop2Src from '@images/marketing/Team-Numbers-2.jpg';
import timelineScallop3Src from '@images/marketing/Team-Numbers-3.jpg';
export var timelineSectionContent = {
    timelineItems: [
        {
            title: '2014',
            description: 'The year we were founded. Dreamed up in a 5x10 San Francisco apartment kitchen, by one very special dog and two very devoted pet parents.',
            imageData: {
                src: timelineScallop1Src,
                alt: 'A headshot of a long hair Chihuahua',
            },
        },
        {
            title: '170+',
            description: 'Dogs between us, pawing at our legs during very important meetings. Louie, Otis, Arthur, Caroline, Libby, Harlee, Franklin — these are our people.',
            imageData: {
                src: timelineScallop2Src,
                alt: 'A headshot of a black Pomeranian',
            },
        },
        {
            title: '3,000,000+',
            description: 'Boxes of fresh food delivered to date. A combined effort from every corner of our company, with no plans of slowing down anytime soon.',
            imageData: {
                src: timelineScallop3Src,
                alt: 'A headshot of an English Sheepdog',
            },
        },
    ],
};
